import { render } from "./CustomInputUploadImage.vue?vue&type=template&id=3b3a1906&scoped=true"
import script from "./CustomInputUploadImage.vue?vue&type=script&lang=js"
export * from "./CustomInputUploadImage.vue?vue&type=script&lang=js"

import "./CustomInputUploadImage.vue?vue&type=style&index=0&id=3b3a1906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3a1906"]])

export default __exports__